<template>
    <div class="card p10 mt20" v-if="softDelete === false">
        <div class="editBlock">
            <button class="btn btn-default btn-sm" data-toggle="modal"
                    data-target="#myModal-2" @click.prevent="handleEditClick"><i class="fa fa-edit"></i></button>
            <button class="btn btn-danger btn-sm" @click.prevent="confirmDelete = true"><i class="fa fa-close"></i></button>
            <div
                    v-if="confirmDelete"
                    class="confirm-delete-popup">
                <button class="btn btn-danger btn-sm" @click.prevent="handleDeleteClick"><i class="icon ion ion-ios-checkmark-outline"></i></button>
                <button class="btn btn-default btn-sm" @click.prevent="confirmDelete = false"><i class="icon ion ion-ios-close-outline"></i></button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="image">
                    <img :src="getSvg" alt="image">
                </div>
            </div>
            <div class="col-md-10">
                <div class="row h-100">
                    <div class="col-md-12 d-flex flex-column justify-content-center">
                        <h6 class="mt10">{{ rowReference !== '' ? rowReference : rowName }}</h6>
                        <p class="greyColor italic" v-if="rowReference !== ''">{{ rowName }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            row: {
                required: true,
                type: Object
            }
        },
        data: function () {
            return {
                currentRow: null,
                softDelete: false,
                confirmDelete: false,
            }
        },
        methods: {
            handleEditClick(){
                this.$emit('rowEditClicked', this.currentRow);
            },
            handleDeleteClick(){
                this.softDelete = true;
                this.$emit('rowDeleteClicked', this.currentRow);
            }
        },
        computed: {
            getSvg(){
                return this.row.type.icon;
            },
            rowName () {
                return this.$store.state.composer.translations.type[this.currentRow.type.name] || this.currentRow.type.name;
            },
            rowReference () {
                return this.currentRow.reference;
            },

        },
        watch: {},
        mounted() {
        },
        created() {
            this.currentRow = this.row;
        }

    }
</script>

<style scoped lang="scss">
    .confirm-delete-popup {
        position: absolute;
        top: -4px;
        right: -4px;
        width: 71px;
        background: white;
        padding: 4px;
        box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
        border-radius: 3px;
        i {
            font-size: 14px;
        }
    }
</style>
